/* eslint-disable no-duplicate-imports */
import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import {Box, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography} from '@mui/material'
import {Close} from '@mui/icons-material'
import {CustomTextBox} from '../../../../Inputs/index.js'
import {CustomButton} from '../../../../Inputs/index.js'
import MyDiv from './insertAreaDialog.style.js'

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />
})


export default function InsertAreaDialog(props) {

  const popup = (popupbox) => (
    <MyDiv>
      <Box className="dialog_box">
        <Box className="dialog_header">
          <DialogTitle className="dialog_title"> {props.item ? props.item.name : ''}</DialogTitle>
          <IconButton className="icon" onClick={props.handleDialog}><Close /></IconButton>
        </Box>
        <Divider />
        <DialogContent className="dialog_content">
          <Typography className="label"> {props.item ? props.item.title : ''}</Typography>
          <CustomTextBox autoFocus className="areaField" value={props.addArea ?? ''} onChange={props.handleChangeArea} name="type_add" />
        </DialogContent>
        <Typography className="label"> {props.item ? props.item.length : ''}</Typography>
        <DialogActions>
          <Box className="d-flex btn-flex mb-20 mt-10">
            <CustomButton
              title="Save"
              variant="contained"
              className="btn_theme"
              onClick={props.handleAdd}
              disabled={!props.addArea}
            />
            <CustomButton
              title="Cancel"
              variant="contained"
              className="btn_theme"
              onClick={props.handleDialog}
            />
          </Box>
        </DialogActions>
      </Box>
    </MyDiv>
  )
  return (
    <Dialog
      popupbox="openDialog"
      open={props.openDialog}
      TransitionComponent={Transition}
      onClose={props.handleDialog}
      fullWidth
    >
      {popup('openDialog')}
    </Dialog>
  )
}
